import React from "react";
import "./TermsAndConditions.css";


function TermsAndConditions() {
  return (
    <div className="container text-gray-800 navbar-offset">

      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">

          <h1 className="display-4 fw-bold mb-3 text-primary TermsAndConditions-heading-h1">
            Terms & Conditions
          </h1>
          <p className="text-muted small mb-4 TermsAndConditions-paragraph">
            Last updated: April 09, 2025
          </p>

          <p className="mb-4 TermsAndConditions-paragraph">
            Welcome to <strong>LankaLearners.lk</strong>! By accessing or using
            our website, you agree to be bound by these Terms and Conditions.
            Please read them carefully.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            1. Acceptance of Terms
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            By using this website, you agree to these Terms and Conditions and
            our Privacy Policy. If you do not agree, please do not use the
            website.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            2. Educational Purpose
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            LankaLearners.lk is an educational platform designed to help users
            prepare for the Sri Lankan driving license theory exam. All content
            is provided for informational and educational purposes only.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            3. No Government Affiliation
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            This website is not affiliated with the Government of Sri Lanka or
            the Department of Motor Traffic (DMT). For official exam details,
            please visit the
            <a
              href="https://dmt.gov.lk"
              target="_blank"
              rel="noopener noreferrer"
              className="ms-1 text-primary text-decoration-underline"
            >
              DMT official website
            </a>
            .
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            4. Intellectual Property
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            All content on this site including text, graphics, and images is the
            property of MechSIT (PVT) LTD unless otherwise stated. Unauthorized
            use is prohibited.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            5. Limitation of Liability
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            We are not liable for any damages resulting from the use or
            inability to use the website or from any content inaccuracies.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            6. Modifications
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            We reserve the right to update or modify these Terms at any time.
            Continued use of the website constitutes acceptance of the new
            terms.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            7. User Conduct
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            You agree not to misuse this site, upload harmful content, or engage
            in any behavior that may interfere with others’ access or
            experience.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            8. Governing Law
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            These Terms shall be governed by the laws of Sri Lanka, and any
            disputes will be subject to the jurisdiction of Sri Lankan courts.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 TermsAndConditions-heading-h2 ">
            9. Contact Information
          </h2>
          <p className="mb-4 TermsAndConditions-paragraph">
            If you have any questions about these Terms & Conditions, contact
            us:
          </p>
          <ul className="list-unstyled ms-3 mb-4 TermsAndConditions-paragraph">
            <li className="mb-1">
              📧 Email:{" "}
              <a
                href="mailto:lankalearners59@gmail.com"
                className="text-decoration-underline text-primary"
              >
                lankalearners59@gmail.com
              </a>
            </li>
            <li className="mb-1 ">
              📞 Phone:{" "}
              <a
                href="tel:+94765747783"
                className="text-decoration-underline text-primary"
              >
                +94 76 574 7783
              </a>
            </li>
            <li className="mb-1">
              🌐 Website:{" "}
              <a
                href="https://lankalearners.lk/contact-lanka-learners"
                className="text-decoration-underline text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://lankalearners.lk/contact-lanka-learners
              </a>
            </li>
          </ul>

          <p className="text-muted small TermsAndConditions-paragraph">
            Thank you for using LankaLearners.lk to support your learning
            journey!
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
